import { Link } from "react-router-dom";
import { useClassrooms } from "../data/ClassroomContext";
import { useReviewQueue } from "../data/useClassroomWorkspace";
import { CheckIcon } from "../components/Icons";
import WorkspaceStatus from "../components/WorkspaceStatus";
import { formatWhen, lessonText } from "../components/WorkState";
import ui from "../components/ui.module.css";
import AssignmentList from "./Assignments";

// Completed learner work nobody has reviewed yet, newest first. The teacher
// never has to remember which lesson it came from.
const Work = () => {
  const { active } = useClassrooms();
  const queue = useReviewQueue(active.id);
  const items = queue.data?.items || [];
  const total = queue.data?.total ?? 0;

  return (
    <div className={ui.page}>
      <div className={ui.stack}>
        <h1 className={ui.title}>Work to review</h1>
        <p className={ui.eyebrow}>
          {[active.name, queue.data && `${total} to review`].filter(Boolean).join(" · ")}
        </p>
      </div>

      <WorkspaceStatus resource={queue} loadingLabel="Loading work to review…" className={active.name} />

      {queue.data &&
        (items.length ? (
          <>
            <ul className={ui.list}>
              {items.map((item) => (
                <li key={item.attemptId} className={`${ui.card} ${ui.workItem}`}>
                  <div className={ui.stack} style={{ gap: "0.25rem" }}>
                    <h2 className={ui.cardTitle}>{item.learner.name}</h2>
                    <p className={ui.learnerName}>{item.activity.title}</p>
                    <p className={ui.meta}>
                      {[lessonText(item), item.completedAt && `Finished ${formatWhen(item.completedAt)}`]
                        .filter(Boolean)
                        .join(" · ")}
                    </p>
                  </div>
                  <Link
                    to={`/work/${item.attemptId}`}
                    state={{ from: "/work" }}
                    className={`${ui.button} ${ui.primary}`}
                    aria-label={`Review ${item.learner.name}: ${item.activity.title}`}
                  >
                    Review
                  </Link>
                </li>
              ))}
            </ul>
            {total > items.length && (
              <p className={ui.meta}>
                Showing the {items.length} most recent. Older work appears here as you review.
              </p>
            )}
          </>
        ) : (
          <div className={`${ui.card} ${ui.stack}`} role="status">
            <span className={`${ui.state} ${ui.done}`}>
              <CheckIcon />
              All caught up
            </span>
            <p>Completed learner work appears here until you review it.</p>
          </div>
        ))}

      <AssignmentList />
    </div>
  );
};

export default Work;
